export default "__VITE_ASSET__D3X94OqK__"